import React from "react";
import "../assets/css/Contact.css";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";
import Form from "../component/Form";
import CommonBanner from "../component/CommonBanner";

function Contact() {
  const breadcrumb = [
    {
      page: "Home",
      url: "/",
    },
    {
      page: "Contact",
      url: "/contact",
    },
  ];

  return (
    <>
      <CommonBanner
        title="Contact Us"
        image="/images/contact.png"
        breadcrumb={breadcrumb}
        color="#fff"
      />

      <section className="contactSection">
        <div className="container">
          <div className="contactGrid">
            <div className="contactInfo">
              <div className="contactCard">
                <div className="contactIcon">
                  <FaMapMarkerAlt />
                </div>

                <div>
                  <h4>Office</h4>
                  <p>#308, 3rd Floor, Suncity Road, Suncity, Sector 54, Gurugram, Haryana 122011</p>
                </div>
              </div>

              <div className="contactCard">
                <div className="contactIcon">
                  <FaPhoneAlt />
                </div>

                <div>
                  <h4>Call Us</h4>
                  <a href="tel:8178749372">+91 8178749372</a>
                </div>
              </div>

              <div className="contactCard">
                <div className="contactIcon">
                  <FaEnvelope />
                </div>

                <div>
                  <h4>Email</h4>
                  <a href="mailto:info@property4sure.com">
                    info@property4sure.com
                  </a>
                </div>
              </div>

              <div className="contactCard">
                <div className="contactIcon">
                  <FaClock />
                </div>

                <div>
                  <h4>Timing</h4>
                  <p>Mon - Sat | 9 AM - 8 PM</p>
                </div>
              </div>

              <div className="contactMap">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.4572925526836!2d77.1118841!3d28.435628299999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1f8c29852f2d%3A0x3bfcd751b4779ecd!2sProperty4Sure!5e0!3m2!1sen!2sin!4v1784881155333!5m2!1sen!2sin" loading="lazy"></iframe>
              </div>
            </div>

            <div className="contactForm">
              <Form />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
